import { combineArguments } from "./object";

export function buildQuery() {
    let queryObject = combineArguments(arguments);
    return objectToParams(queryObject);
}

export function objectToParams(params) {
    return Object.keys(params)
        .map(key => {
            let param = "";

            if (Array.isArray(params[key])) {
                param = params[key].length ? params[key].join("+") : null;
            } else {
                param = params[key] ? params[key] : null;
            }

            return param ? key + "=" + param : null;
        })
        .filter(item => (item ? true : false))
        .join("&");
}

export function apiURL() {
    let apiURL = "";
    if (process.env.NODE_ENV === "development") {
        apiURL = process.env.MIX_API_DEVELOPMENT ? process.env.MIX_API_DEVELOPMENT : "";
    } else {
        apiURL = process.env.MIX_API_PRODUCTION ? process.env.MIX_API_PRODUCTION : "";
    }

    return apiURL;
}
